export default __webpack_public_path__ + "static/media/userDefault.a8759827.png";